// ======================================================================
// File Name       : DiscriminationDegreeDataContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React, { Component } from 'react';
import moment from 'moment';
import { Field, reduxForm, isInvalid, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import DiscriminationDegreeDataSearch from '../../components/adaptive/DiscriminationDegreeDataSearch';
import * as MessageTemplate from '../../constants/MessageTemplate';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import DialogConfirm from '../../components/DialogConfirm';
import * as adaptiveAction from '../../actions/AdaptiveAction';
import { showLoading, hideLoading } from '../../utils/PageUtils';
import { showExportCSVSuccessMessage } from '../../utils/index';

class DiscriminationDegreeDataContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.initData = this.initData.bind(this);
    this.onDialogExportCancel = this.onDialogExportCancel.bind(this);
    this.openExportDialog = this.openExportDialog.bind(this, MessageTemplate.BULK_EXPORT, null);
    this.onExportDialogOk = this.onExportDialogOk.bind(this);
    this.openCollectiveReflectionDialog = this.openCollectiveReflectionDialog.bind(this, MessageTemplate.COLLECTIVE_REFLECTION, null);
    this.onCollectiveReflectionCancel = this.onCollectiveReflectionCancel.bind(this);
    this.onCollectiveReflectionOk = this.onCollectiveReflectionOk.bind(this);
  }

  componentWillMount() {
    this.initData();
  }

  initData() {
    this.props.dispatch(adaptiveAction.getCourseList());
  }

  openExportDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showExportModal: true });
  }

  openCollectiveReflectionDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showCollectiveReflectionModal: true });
  }

  createParams(data) {
    const param = data;
    return param;
  }

  onExportDialogOk() {
    const { formValues } = this.props;
    this.setState({ showExportModal: false }, () => {
      this.props.dispatch(adaptiveAction.exportCourse()).then(() => {
        showExportCSVSuccessMessage();
      });
    });
  }

  onCollectiveReflectionOk() {
    const { formValues } = this.props;
    let param = {};
    if (formValues && formValues.numberThreshold) {
      param = {
        thresholdSampleNumber: formValues.numberThreshold,
      };
    }
    this.props.dispatch(showLoading());
    this.setState({ showCollectiveReflectionModal: false }, () => {
      this.props.dispatch(adaptiveAction.collectiveReflection(param)).then(() => {
        this.props.dispatch(hideLoading());
      });
    });
  }

  onCollectiveReflectionCancel() {
    this.setState({ showCollectiveReflectionModal: false });
  }

  onDialogExportCancel() {
    this.setState({ showExportModal: false });
  }

  render() {
    const { courseListData, formValues } = this.props;
    return (
      <div>
        <Header name="難易度・識別度データ管理" />
        <DiscriminationDegreeDataSearch
          {...formValues}
          courseListData={courseListData}
          openExportDialog={this.openExportDialog}
          handleSubmit={this.props.handleSubmit}
          openCollectiveReflectionDialog={this.openCollectiveReflectionDialog}
        />
        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onDialogExportCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onExportDialogOk}
        />
        <DialogConfirm
          showModal={this.state.showCollectiveReflectionModal}
          onCancel={this.onCollectiveReflectionCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onCollectiveReflectionOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const initial = {
    numberThreshold: 300,
  };
  const { courseListData } = state.adaptive;
  return {
    initialValues: initial,
    formValues: getFormValues('discriminationDegreeData')(state),
    courseListData,
  };
};

export default connect(mapStateToProps)(reduxForm({
  form: 'discriminationDegreeData', // a unique identifier for this form
  touchOnChange: true,
})(DiscriminationDegreeDataContainer));
